module.exports = __webpack_public_path__ + "static/tu-logo-twitter-card-3b6eec17586ca33d0a00121932951e04.jpg";